import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { GroupActionValidationStatus } from "../sidebar-toolbar-types";

export function useGroupLayerTooltip(status: GroupActionValidationStatus) {
    const translate = useIventisTranslate();

    switch (status) {
        case GroupActionValidationStatus.InvalidNestedLevel:
            return translate(Content.map11.map_group_status.nested_level);
        case GroupActionValidationStatus.InvalidParent:
            return translate(Content.map11.map_group_status.parent);
        case GroupActionValidationStatus.InvalidSelectionAmount:
            return translate(Content.map11.map_group_status.amount);
        case GroupActionValidationStatus.InvalidPermissions:
            return translate(Content.map11.map_group_status.permissions);
        case GroupActionValidationStatus.InvalidTypeSelection:
            return translate(Content.map11.map_group_status.type);
        case GroupActionValidationStatus.MapLoading:
            return translate(Content.map11.map_group_status.loading);
        case GroupActionValidationStatus.Valid:
            return translate(Content.map11.map_group_status.explain);
        default:
            throw new Error(`Status of ${status} not handled`);
    }
}
